export default "__VITE_ASSET__WlxkJTWj__"